export default __webpack_public_path__ + "media/images/brands/burgon-and-ball-6eb3cabbca69671ab7be031089696583.png";